import React, { useContext } from "react";
import { TMDataContext } from "../../../utils/custom_hooks/TMDataContext";
import { FormNavigationControllerPropsShape } from "../../interfaces/componentTypes";
import { GoalFormNavigationButton } from "./generalUtilities";

export const FormNavigationController: React.FC<FormNavigationControllerPropsShape> = ({
  stepComplete: allowNextAndSave,
  goalState,
}) => {
  const {
    DBObject,
    setPageStatus,
    t,
    api,
    router,
    navPage,
    setNavPage,
    uuid,
    setTemplateSet,
  } = useContext(TMDataContext);

  const renderedOptions = (options) => {
    return options.map((option) => {
      if (option == "preview") {
        return (
          <GoalFormNavigationButton
            title={option}
            key={uuid()}
            allow={allowNextAndSave}
            handleClick={handleNavigate}
          />
        );
      } else {
        return (
          <GoalFormNavigationButton
            title={option}
            key={uuid()}
            allow={true}
            handleClick={handleNavigate}
          />
        );
      }
    });
  };

  const handleNavigate = (point) => {
    let clicked = point.target.value;

    if (clicked == "preview") {
      setNavPage(router.goToPreview(navPage));
    }
    if (clicked == "edit") {
      setNavPage(router.goToEditCurrent(navPage));
    }
    if (clicked == "cancel") {
      if (confirm(t("views.goals.navigation.cancel_prompt"))) {
        setNavPage(router.goToHomepage());
      } else {
        null;
      }
    }
    if (clicked == "save") {
      if (navPage.CRUDType == "create") {
        let newGoalTemplate = goalState.formatForLocalSave();
        newGoalTemplate["createdAtFormatted"] = t(
          "views.goals.navigation.save_for_created_at_date"
        );
        newGoalTemplate["id"] = `temp_${uuid()}`;
        setTemplateSet("create", newGoalTemplate);
        return setNavPage(router.goToHomepage());
      }
      if (navPage.CRUDType == "edit") {
        let newUpdatedGoalPayload = goalState.formatForLocalSave();

        if (goalState.createdAtFormatted == null) {
          newUpdatedGoalPayload["createdAtFormatted"] = t(
            "views.goals.navigation.save_for_created_at_date"
          );
        }
        newUpdatedGoalPayload["id"] = goalState.id;
        setTemplateSet("edit", newUpdatedGoalPayload);
        return setNavPage(router.goToHomepage());
      }
    }
  };

  return (
    <div className="goal-form-footer-block">
      {renderedOptions(navPage.navOptions)}
    </div>
  );
};
